import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Box, MenuItem, MenuList, Paper, Popper, Tooltip } from "@mui/material";
import { commonTooltipProps } from "../../../Utils";
const KEYS = {
    ENTER: "Enter",
    ESC: "Escape",
    UP: "ArrowUp",
    DOWN: "ArrowDown"
};
export const QuillMentionMenu = (props) => {
    var _a, _b, _c;
    const [focusIndex, setFocusIndex] = useState(-1);
    const selectedMenuItemRef = useRef();
    const matches = props.mentionOptions.filter(mention => mention.value.toLowerCase().includes(props.searchTerm.toLowerCase()));
    useEffect(() => {
        if (props.mentionMenuOpen) {
            const enabledMentionIndex = matches.findIndex(match => !match.disabled);
            setFocusIndex(enabledMentionIndex);
        }
        else {
            setFocusIndex(-1);
        }
    }, [props.mentionMenuOpen, props.searchTerm]);
    useEffect(() => {
        var _a;
        if (props.mentionMenuOpen && focusIndex !== -1) {
            (_a = selectedMenuItemRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
    }, [props.mentionMenuOpen, focusIndex]);
    const onSelect = (item) => {
        const format = props.quillRef.current.getEditor().getFormat();
        const range = props.quillRef.current.getEditor().getSelection();
        props.quillRef.current.getEditor().getModule("mention").insertItem({ id: item.id, value: `{${item.value}}` });
        // apply formatting to the mention
        props.quillRef.current.getEditor().formatText(range.index - 1, 1, format, "user");
    };
    const onArrowNavigation = (isDown) => {
        var _a;
        if (!matches.some(m => !m.disabled)) {
            return;
        }
        const getNewIndex = (index, isDown) => ((isDown ? 1 : -1) + index + matches.length) % matches.length;
        let newIndex = getNewIndex(focusIndex, isDown);
        while ((_a = matches[newIndex]) === null || _a === void 0 ? void 0 : _a.disabled) {
            newIndex = getNewIndex(newIndex, isDown);
        }
        setFocusIndex(newIndex);
    };
    const onKeyDown = (e) => {
        // do not intercept key events if the suggestions overlay is not shown
        if (!props.mentionMenuOpen || !matches.length) {
            return;
        }
        switch (e.key) {
            case KEYS.ESC: {
                e.preventDefault();
                e.stopPropagation();
                props.closeMenu();
                return;
            }
            case KEYS.DOWN: {
                e.preventDefault();
                e.stopPropagation();
                onArrowNavigation(true);
                return;
            }
            case KEYS.UP: {
                e.preventDefault();
                e.stopPropagation();
                onArrowNavigation(false);
                return;
            }
            case KEYS.ENTER: {
                e.preventDefault();
                e.stopPropagation();
                if (matches[focusIndex] && !matches[focusIndex].disabled) {
                    onSelect(matches[focusIndex]);
                }
                return;
            }
            default: {
                return;
            }
        }
    };
    props.onKeyDownCallbackRef.current = onKeyDown;
    if (!matches.length && (props.searchTerm || !props.emptySuggestionElement)) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(Popper, { open: props.mentionMenuOpen, sx: { zIndex: 1301 }, anchorEl: (_a = props.quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditingArea(), placement: "bottom-start", modifiers: [
            {
                name: "offset",
                options: {
                    offset: [((_b = props.mentionMenuPositionOffset) === null || _b === void 0 ? void 0 : _b.left) || 0, ((_c = props.mentionMenuPositionOffset) === null || _c === void 0 ? void 0 : _c.top) || 0]
                }
            }
        ], children: _jsx(Paper, { color: "common.white", children: matches.length ? _jsx(MenuList, { variant: "menu", sx: mentionListSxProps, children: matches.map((item, index) => {
                    const menuItem = (_jsx(MenuItem, { component: "div", sx: { height: "100%", width: "100%", whiteSpace: "break-spaces" }, "data-testid": `${props.dataTestId}-menu-item-${item.value}`, "data-tracking-id": props.suggestionTrackingId, disabled: item.disabled, onClick: () => onSelect(item), onMouseOver: () => setFocusIndex(index), selected: index === focusIndex, ref: index === focusIndex ? selectedMenuItemRef : undefined, children: item.value }, item.id));
                    return !item.disabled ? menuItem : (_jsx(Box, { "aria-disabled": "true", sx: { height: "100%", width: "100%", cursor: "auto" }, onMouseDown: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }, children: _jsx(Tooltip, Object.assign({ title: item.disabledTooltip }, commonTooltipProps, { slotProps: { tooltip: { sx: { p: "8px" } } }, children: _jsx(Box, { sx: { height: "100%" }, children: menuItem }) })) }, item.id));
                }) }) : props.emptySuggestionElement }) }));
};
const mentionListSxProps = {
    maxHeight: "400px",
    overflowY: "auto",
    width: "240px",
    overflowX: "hidden"
};
//# sourceMappingURL=QuillMentionMenu.js.map